export default "__VITE_ASSET__CJH7Fe8N__"